/**
 * Replace following characters with space
 *  - U+00A0 No-Break Space - Used by testcafe https://github.com/DevExpress/testcafe/pull/2388
 *  - U+2000 - U+2009 En/Em Quad and Space
 *  - U+200A Hair space
 *  - U+200B Zero Width Space
 *  - U+202F Narrow No-Break Space
 *  - U+205F Medium Mathematical Space
 *  - U+3000 Ideographic Space
 */
export function sanitizeText(value: string): string {
  return value.replace(
    /[\u00A0\u2000-\u2009\u200A\u200b\u202f\u205f\u3000]/g,
    ' ',
  );
}
